import { render, staticRenderFns } from "./p05.vue?vue&type=template&id=80072456&scoped=true&"
import script from "./p05.vue?vue&type=script&lang=js&"
export * from "./p05.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80072456",
  null
  
)

export default component.exports